import { Link, useLocation } from "react-router-dom";
import { STORAGE_KEY, swapLocale, useLocale } from "../i18n";

const OPTIONS = [
  { lang: "en", label: "EN" },
  { lang: "ja", label: "日本語" },
];

export const LanguageSwitcher = ({ id = "header", className = "" }) => {
  const current = useLocale();
  const { pathname, search, hash } = useLocation();
  return (
    <div className={`flex items-center gap-2 text-[12px] tracking-[0.12em] sm:gap-2.5 ${className}`} data-testid={`${id}-lang-switcher`}>
      {OPTIONS.map((o, i) => (
        <span key={o.lang} className="flex items-center gap-2 sm:gap-2.5">
          {i > 0 && <span className="h-3 w-px bg-current opacity-30" aria-hidden />}
          <Link
            to={`${swapLocale(pathname, o.lang)}${search}${hash}`}
            onClick={() => localStorage.setItem(STORAGE_KEY, o.lang)}
            hrefLang={o.lang}
            lang={o.lang}
            aria-current={current === o.lang ? "true" : undefined}
            data-testid={`${id}-lang-${o.lang}`}
            className={`lang-option inline-flex min-h-[44px] items-center transition-opacity duration-300 ${current === o.lang ? "opacity-100" : "opacity-45 hover:opacity-100"}`}
          >
            {o.label}
          </Link>
        </span>
      ))}
    </div>
  );
};
